import React, { useState, useEffect } from "react";

interface SmartSkeletonProps {
  children: React.ReactNode;
  delay?: number; // Delay in milliseconds (default 200ms)
}

/**
 * SmartSkeleton: Prevents skeleton "flickering" on fast connections.
 * It waits for 'delay', and only shows the skeleton if data hasn't loaded.
 * Big Tech companies use this to avoid jarring visual jumps for fast users.
 */
const SmartSkeleton: React.FC<SmartSkeletonProps> = ({ children, delay = 200 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!show) return null;

  return <>{children}</>;
};

export default SmartSkeleton;
